import Template from "./template";
import paper from "paper";
import { DEFAULT_CHANNEL_WIDTH_UM } from "./channelWidths";

export default class Transition extends Template {
    constructor() {
        super();
    }

    __setupDefinitions(): void  {
        this.__unique = {
            position: "Point"
        };

        this.__heritable = {
            componentSpacing: "Float",
            cw1: "Float",
            cw2: "Float",
            length: "Float",
            rotation: "Float",
            depth: "Float",
            mirrorByX: "Float",
            mirrorByY: "Float"
        };

        this.__defaults = {
            componentSpacing: 2000,
            cw1: DEFAULT_CHANNEL_WIDTH_UM,
            cw2: 0.9 * 1000,
            length: 1.0 * 1000,
            rotation: 0,
            depth: 250,
            mirrorByX: 0,
            mirrorByY: 0
        };

        this.__units = {
            componentSpacing: "μm",
            cw1: "μm",
            cw2: "μm",
            length: "μm",
            rotation: "°",
            depth: "μm"
        };

        this.__minimum = {
            componentSpacing: 0,
            cw1: 3,
            cw2: 3,
            length: 10,
            depth: 10,
            rotation: 0,
            mirrorByX: 0,
            mirrorByY: 0
        };

        this.__maximum = {
            componentSpacing: 10000,
            rotation: 180,
            cw1: 2000,
            cw2: 2000,
            length: 1200,
            depth: 1200,
            mirrorByX: 1,
            mirrorByY: 1
        };

        this.__featureParams = {
            componentSpacing: "componentSpacing",
            position: "position",
            cw1: "cw1",
            cw2: "cw2",
            length: "length",
            rotation: "rotation",
            mirrorByX: "mirrorByX",
            mirrorByY: "mirrorByY"
        };

        this.__targetParams = {
            componentSpacing: "componentSpacing",
            cw1: "cw1",
            cw2: "cw2",
            length: "length",
            rotation: "rotation",
            mirrorByX: "mirrorByX",
            mirrorByY: "mirrorByY"
        };

        this.__placementTool = "PositionTool";

        this.__toolParams = {
            position: "position"
        };

        this.__renderKeys = ["FLOW"];

        this.__mint = "TRANSITION";

        this.__zOffsetKeys = {
            FLOW: "depth"
        };

        this.__substrateOffset = {
            FLOW: "0"
        };
    }

    render2D(params: { [k: string]: any }, key: string): paper.Path  {
        const position = params.position;
        const cw1 = params.cw1;
        const cw2 = params.cw2;
        const length = params.length;
        const rotation = params.rotation;
        const color = params.color;
        const trap = new paper.Path();

        trap.add(new paper.Point(position[0] - cw1 / 2, position[1]));
        trap.add(new paper.Point(position[0] + cw1 / 2, position[1]));
        trap.add(new paper.Point(position[0] + cw2 / 2, position[1] + length));
        trap.add(new paper.Point(position[0] - cw2 / 2, position[1] + length));
        // trap.add(new paper.Point(position[0] - cw1/2, position[1]));

        trap.closed = true;
        trap.fillColor = color;
        this.transformRender(params,trap);
        return trap;
    }

    render2DTarget(key: string | null, params: { [k: string]: any }): paper.Path  {
        if (key === null) {
            key = this.__renderKeys[0];
        }
        const render = this.render2D(params, key);
        render.fillColor!.alpha = 0.5;
        return render;
    }
}
